var columnAdjust = {
	init : function(){
		if (breakpoint === 4) {
			$('body').addClass('column-count-3');
		}
		else if (breakpoint === 3) {
			$('body').addClass('column-count-2');
		}
		else if (breakpoint < 3) {
			$('body').addClass('column-count-1');
		}
		columnAdjust.checkForFeaturedWide();
		columnAdjust.checkTheLayout();
	},
	pageResize : function() {
		$('.dynamic-column-1-header').removeClass('dynamic-column-1-header');
		$('.dynamic-column-2-header').removeClass('dynamic-column-2-header');
		$('.dynamic-column-3-header').removeClass('dynamic-column-3-header');
		
	},
	checkForFeaturedWide : function() {
	/*
		if ($('#full-width-feature').length > 0) {
			if ($('body').hasClass('column-count-3')) {
				$('#full-width-feature').before("<ul class='cards pre-full-width-feature'></ul>");

				$('.cards').eq(1).find('.card').each(function(i){
					var rowNum = (Number($('#full-width-feature').data('row'))-1) * 3
				
					if (i < rowNum) {
						$(this).appendTo('.pre-full-width-feature');
					}
				});
				
				
			}
			if ($('body').hasClass('column-count-2')) {
			
			}
			else {
			
			}			
		}
		*/
	},
	checkTheLayout : function() {
		if ($('body').hasClass('column-count-3')) {
			columnAdjust.threeColumnLayout();
		}
		else if ($('body').hasClass('column-count-2')) {
			columnAdjust.twoColumnLayout();
		}
		else {
			columnAdjust.oneColumnLayout();
		}
	},
	threeColumnLayout : function() {
		$('.masonry.cards').each(function(s) {
			$(this).find('.card').each(function(i) {
				var cardDivider = (i+1) % 3;
				if (cardDivider === 1) {
					$(this).addClass('dynamic-column-1');
				}
				else if (cardDivider === 2) {
					$(this).addClass('dynamic-column-2');			
				}
				else if (cardDivider === 0){
					$(this).addClass('dynamic-column-3');			
				}
			});
		});
		columnAdjust.updateMarkup();
	},
	twoColumnLayout : function() {
		$('.masonry.cards').each(function(s) {
			$(this).find('.card').each(function(i) {
				var cardDivider = (i+1) % 2;
				if (cardDivider === 1) {
					$(this).addClass('dynamic-column-1');
				}
				else if (cardDivider === 0) {
					$(this).addClass('dynamic-column-2');			
				}
			});
		});
		columnAdjust.updateMarkup();
	},
	oneColumnLayout : function() {
		$('.masonry.cards').each(function(s) {
			$(this).find('.card').each(function(i) {
				$(this).addClass('dynamic-column-1');
			});
		});
		columnAdjust.updateMarkup();
	},
	updateMarkup : function() {
		$('.masonry.cards').each(function(z){
			if (!$(this).hasClass('extra-wide-article')) {
				var self=this;
				$(this).prepend('<div class="dynamic-column-1-header "></div><div class="dynamic-column-2-header "></div><div class="dynamic-column-3-header "></div>')
				var findCounterOne = 0;
				var findCounterTwo = 0;
				var findCounterThree = 0;
				
				$(this).find('.dynamic-column-1').each(function(i){
					findCounterOne++;
				});
				$(this).find('.dynamic-column-2').each(function(i){
					findCounterTwo++;
				});
				$(this).find('.dynamic-column-3').each(function(i){
					findCounterThree++;
				});
				$(this).find('.dynamic-column-1').each(function(i){
					if (i === 0) {// first item in set
						$(self).find('.dynamic-column-1-header').append(this);
						if (Number(i+1) != findCounterOne) {
								$(this).addClass('temp-previous');
						}
					}
					else if (Number(i+1) === findCounterOne) { // last item in set
						$('.temp-previous').after(this)
						$('.temp-previous').removeClass('temp-previous');
						$(this).removeClass('temp-previous');
					}
					else {
						$('.temp-previous').after(this)
						$('.temp-previous').removeClass('temp-previous');
						$(this).addClass('temp-previous');
					}
				});			
				$(this).find('.dynamic-column-2').each(function(i){
					if (i === 0) {// first item in set
						$(self).find('.dynamic-column-2-header').append(this);
						if (Number(i+1) != findCounterTwo) {
							$(this).addClass('temp-previous');
						}
					}
					else if (Number(i+1) === findCounterTwo) { // last item in set
						$('.temp-previous').after(this)
						$('.temp-previous').removeClass('temp-previous');
						$(this).removeClass('temp-previous');
					}
					else {
						$('.temp-previous').after(this)
						$('.temp-previous').removeClass('temp-previous');
						$(this).addClass('temp-previous');
					}
				});
				$(this).find('.dynamic-column-3').each(function(i){
					if (i === 0) {// first item in set
						$(self).find('.dynamic-column-3-header').append(this);
						if (Number(i+1) != findCounterThree) {
							$(this).addClass('temp-previous');
						}
					}
					else if (Number(i+1) === findCounterThree) { // last item in set
						$('.temp-previous').after(this)
						$('.temp-previous').removeClass('temp-previous');
						$(this).removeClass('temp-previous');
					}
					else {
						$('.temp-previous').after(this)
						$('.temp-previous').removeClass('temp-previous');
						$(this).addClass('temp-previous');
					}
				});
			}
		});
	},
	reSort : {
		config : {
			theArray: [],
			cleanSlate: false
		},
		init : function() {
				if ($('.column-count-3').length > 0 || columnAdjust.reSort.config.cleanSlate === true) { // if content in all 3 columns (or if clean slate fired)
					$('.cards.masonry').each(function(x){
						if (!$(this).hasClass('extra-wide-article')) {
							columnAdjust.reSort.config.theArray = []; // clear the array for each unordered list
							$(this).find('.dynamic-column-1').each(function(i){
								columnAdjust.reSort.config.theArray[i * 3] = $(this).clone().removeClass('dynamic-column-1');
							});
							$(this).find('.dynamic-column-2').each(function(i){
								columnAdjust.reSort.config.theArray[(i * 3)+1] = $(this).clone().removeClass('dynamic-column-2');
							});
							$(this).find('.dynamic-column-3').each(function(i){
								columnAdjust.reSort.config.theArray[(i * 3)+2] = $(this).clone().removeClass('dynamic-column-3');
							});
							$(this).html(columnAdjust.reSort.config.theArray);
						}
					});
				}
				else if ($('.column-count-2').length > 0) { // if content in 2 columns
					$('.cards.masonry').each(function(x){
						if (!$(this).hasClass('extra-wide-article')) {
							columnAdjust.reSort.config.theArray = []; // clear the array for each unordered list
							$(this).find('.dynamic-column-1').each(function(i){
								columnAdjust.reSort.config.theArray[i * 2] = $(this).clone().removeClass('dynamic-column-1');
							});
							$(this).find('.dynamic-column-2').each(function(i){
								columnAdjust.reSort.config.theArray[(i * 2)+1] = $(this).clone().removeClass('dynamic-column-2');
							});
							$(this).html(columnAdjust.reSort.config.theArray);
						}
					});			
				}
				else {
					$('.cards.masonry').each(function(x){
						if (!$(this).hasClass('extra-wide-article')) {
							columnAdjust.reSort.config.theArray = []; // clear the array for each unordered list
							$(this).find('.dynamic-column-1').each(function(i){
								columnAdjust.reSort.config.theArray[i] = $(this).clone().removeClass('dynamic-column-1');
							});
							$(this).html(columnAdjust.reSort.config.theArray);
						}
					});	
				}
				columnAdjust.reSort.config.cleanSlate = false;
				$('body').removeClass('column-count-1');
				$('body').removeClass('column-count-2');
				$('body').removeClass('column-count-3');
				
				if (breakpoint === 4) {
					$('body').addClass('column-count-3');
				}
				else if (breakpoint === 3) {
					$('body').addClass('column-count-2');
				}
				else if (breakpoint < 3) {
					$('body').addClass('column-count-1');
				}
				columnAdjust.init();
		}
	}
};




var autoImgAdjust = {
	init : function(){
		$('.small-img').removeClass('small-img');
		$('.card').each(function(){
			var titleHeight = $(this).find('.activityTitle').height();
			var teaserHeight = $(this).find('.teaser').height();
			var thisHeight = titleHeight + teaserHeight;
			if (thisHeight > 180) {
				$(this).addClass('small-img');
			}
		});
		autoImgAdjust.arrangeMarkup();
		autoImgAdjust.displayAllImgs();
	},
	arrangeMarkup : function() {
		$('.small-img').each(function(){
			var self = this;
			if ($(this).find('.activityImage').length > 0) {
				var imgSrc = $(this).attr('src');
				if (typeof imgSrc !== typeof undefined && imgSrc !== false) {
					var copyOfImg = $(this).find('.activityImage').html();
					if ($(this).find('.activityImage img').attr('src').indexOf('icons/placeholder') < 0) {
						$(self).find('.teaser').prepend(copyOfImg);
					}
				}
			}
		});
	},
	displayAllImgs : function() {
		$('.card').removeClass('loading');
	}
}



var displayTheCards = function(){
	$('.cards').show();
};





